import styled from 'styled-components'

export const TargetOnboardingWrapper = styled.div``

export const ContentWrapper = styled.div`
  margin-top: 50px;
  height: 75vh;

  .content_img {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 40px;
    img {
      height: 150px;
      object-fit: cover;
      object-position: center;
    }
  }

  .content_text {
    margin-top: 70px;
  }

  .tribe {
    color: ${({ theme }) => theme.colors.primaryBlue};
  }

  .description p {
    color: ${({ theme }) => theme.colors.darkNavyBlue};
    width: 300px;
    margin: 0;
  }
`
